import React, { ReactNode } from 'react';
import { ReactComponent as IconMenu } from '../../../../assets/icon-mobile-menu.svg';
import { ReactComponent as IconBack } from '../../../../assets/arrow-back.svg';
import styled from 'styled-components';
import colors from '../../../../constants/colors.constants';

export interface MobileGlobalHeaderProps {
  children?: ReactNode;
  leftActionType?: 'back';
  leftAction?: () => void;
  hideLeftButton?: boolean;
}
function MobileHeader(props: MobileGlobalHeaderProps) {
  const {
    hideLeftButton = false,
    leftAction,
    leftActionType = 'menu',
    children = '',
  } = props;
  return (
    <StyledHeaderWrapper className="flex items-center gap-2">
      {!hideLeftButton && leftActionType === 'menu' && (
        <div
          style={{
            padding: '7px',
            cursor: 'pointer',
          }}
          onClick={() => {
            if (leftAction) leftAction();
          }}
        >
          <IconMenu />
        </div>
      )}

      {!hideLeftButton && leftActionType === 'back' && (
        <div
          style={{
            padding: '5px',
            cursor: 'pointer',
            position: 'absolute',
          }}
        >
          <IconBack
            onClick={() => {
              if (leftAction) leftAction();
            }}
          />
        </div>
      )}

      <div
        className="grow"
        style={{
          textAlign: 'center',
          fontSize: 18,
          fontWeight: 700,
          padding: '2px 0',
        }}
      >
        <span
          style={{
            lineHeight: '28px',
          }}
        >
          {children}
        </span>
      </div>
    </StyledHeaderWrapper>
  );
}

export default MobileHeader;

const StyledHeaderWrapper = styled.div`
  background: white;
  width: 100%;
  padding: 8px 16px;
  max-height: 48px;
  min-height: 48px;
  border-bottom: 1px solid ${colors.defaultBorder};
`;
